<app-modal
  [(open)]="open"
  [title]="mode === 'add' ? 'Add Operation' : 'Edit Operation'"
  size="large"
  (closed)="onClose()"
>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-[18px]">
    <!-- Operation ID -->
    <app-form-field
      [error]="form.get('operationId')?.invalid && form.get('operationId')?.touched ? 'Operation ID is required' : null"
    >
      <app-text-input
        formControlName="operationId"
        label="Operation ID"
        placeholder="Enter operation ID"
        [invalid]="!!(form.get('operationId')?.invalid && form.get('operationId')?.touched)"
      />
    </app-form-field>

    <!-- Power Behavior -->
    <app-form-field label="Power Behavior">
      <div class="flex gap-6">
        <label class="flex items-center gap-2 text-[13px] font-semibold text-ink-2">
          <app-toggle formControlName="sleep" />
          Sleep
        </label>
        <label class="flex items-center gap-2 text-[13px] font-semibold text-ink-2">
          <app-toggle formControlName="shutdown" />
          Shutdown
        </label>
      </div>
    </app-form-field>

    <!-- Schedule -->
    <app-form-field label="Schedule">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <app-text-input formControlName="startDate" type="date" label="Start Date" />
        <app-text-input formControlName="endDate" type="date" label="End Date" />
        <app-text-input formControlName="startTime" type="time" [withSeconds]="true" label="Start Time" />
        <app-text-input formControlName="endTime" type="time" [withSeconds]="true" label="End Time" />
      </div>
    </app-form-field>

    <!-- Active Days -->
    <app-form-field label="Active Days">
      <div class="flex flex-wrap gap-3">
        @for (day of weekdays; track day.control) {
          <label class="flex items-center gap-2 text-[13px] font-semibold text-ink-2">
            <app-toggle [formControlName]="day.control" />
            {{ day.label }}
          </label>
        }
      </div>
    </app-form-field>

    <!-- Technical Settings -->
    <app-form-field label="Technical Settings">
      <div class="flex flex-col gap-3">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <app-number-input formControlName="renderInterval" label="Render Interval" [min]="0" unit="ms" />
          <app-number-input formControlName="connectionInterval" label="Connection Interval" [min]="0" unit="ms" />
        </div>
        <app-number-input
          formControlName="illumination"
          label="Illumination (0.0 – 1.0)"
          [min]="0"
          [max]="1"
          [step]="0.1"
        />
        <app-text-input
          formControlName="batteryPowerStatusList"
          label="Battery Power Status List"
          placeholder="e.g. NORMAL, LOW, CRITICAL"
        />
      </div>
    </app-form-field>
  </form>

  <ng-template modalFooter>
    <div class="flex flex-1 items-center justify-end gap-2">
      <button
        type="button"
        (click)="onClose()"
        class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onSubmit()"
        [disabled]="form.invalid"
        class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text disabled:opacity-40 hover:brightness-90"
      >
        {{ mode === 'add' ? 'Add Operation' : 'Save Changes' }}
      </button>
    </div>
  </ng-template>
</app-modal>
